import type { LastMonthRevenueInsightsDTO } from "../models/lastMonthRevenueInsightsDto";
import type { LastMonthRevenueInsightsEntity } from "../../domain/entities/LastMonthRevenueInsightsEntity";

export function lastMonthRevenueInsightsDtoToEntity(
  dto: LastMonthRevenueInsightsDTO,
): LastMonthRevenueInsightsEntity {
  return {
    insights: (dto.insights ?? []).map((item) => ({
      accentColor: (item.accentColor ?? "neutral") as
        | "success"
        | "warning"
        | "neutral",
      description: item.description ?? "",
    })),
    noInsights: dto.no_insights ?? false,
    monthLabel: dto.month_label ?? "",
    message: dto.message ?? null,
  };
}
